<template lang="pug">
v-layout.my-6
  v-row.fill-height.ma-0(align='center' justify='center')
    v-card.pa-16
      h5.mb-4 Registration complete
      .p1.mt-8 Your user registration for {{ this.user.company.name }} is complete. 
      .p1.mt-2 Install Yezza Connect : Chrome Extension to sign in to your account. 
      .mb-8
      v-btn.button-Aa-large(@click="downloadExtension" color="info500" depressed dark) Install
</template>

<script>
export default {
  name: 'InviteConnectComplete',
  props: ['user'],
  data: () => ({}),
  methods: {
    downloadExtension() {
      const url = "https://chrome.google.com/webstore/detail/yezza-connect/eobmibgnoicppllfedccnnokniehnmdp"
      window.open(url, '_blank')
    }
  }
}
</script>